import Typography from '@mui/material/Typography';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prompt from '../../../Prompt/Prompt';
import RMFWelcomeTransition from '../RMFWelcomeTransition/RMFWelcomeTransition';

import {
  TXTWCL_Continue_to_personal_details,
  TXTWCL_Next_upXX,
  TXTWCL_We_need_a_few_more_details_to__ELL,
  TXTWCL_YouXre_in
} from './RMFTransitionScreen.messages.json';

export interface Props {
  handleButtonClick: () => void;
}

const RMFTransitionScreen: React.FC<Props> = ({ handleButtonClick }) => {
  const isSwcSignupRmfEcoTransitionTwo = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);

  if (isSwcSignupRmfEcoTransitionTwo) {
    return <RMFWelcomeTransition setValue={() => handleButtonClick()} />;
  } else {
    return (
      <Prompt
        title={{ translation: TXTWCL_YouXre_in }}
        secondaryTitle={{ translation: TXTWCL_Next_upXX }}
        primaryButton={{ translation: TXTWCL_Continue_to_personal_details }}
        noCloseButton
        onPrimaryButtonClick={() => handleButtonClick()}
        variant="celebration"
      >
        <Typography>
          <Translation {...TXTWCL_We_need_a_few_more_details_to__ELL} />
        </Typography>
      </Prompt>
    );
  }
};

export default RMFTransitionScreen;
